import { InjectionToken } from '@angular/core';
import { LocaleCatalog } from './locale-selector.model';

/** A new instance of the `InjectionToken` class named `LOCALE_LIST`. */
export const LOCALE_LIST = new InjectionToken<LocaleCatalog>('List of locales available');
